module.exports = __webpack_public_path__ + "static/media/about_content_3@768.85b4faf6.png";